import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import auth from "../../../auth";
import axios from "axios";
import InputMask from 'react-input-mask';

import TableArchivos from './TableArchivos';

import { TabContent, TabPane, Nav, NavItem, NavLink, Table, Row, Button, Col, Label, Input, InputGroup, FormFeedback, Alert } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import CurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput.js"
import AgregarCosto from "./AgregarCosto.js"
import CreateLTA from "../../clientes/Responsables/Create.js"
import DetailEmpresas from "../../clientes/Empresas/Detail.js"

import dateFunctions from '../../functions/dateFunctions';

var columnStyle = {
    minWidth: "125px",
    maxWidth: "125px"
}

var columnStyleObs = {
    minWidth: "200px",
    maxWidth: "200px"
}

var FieldStyle = {
    maxWidth: "100%"
}

var buttonStyle = {
    fontSize: "10px",
    padding: "1.5px 5px",
    marginTop: "-2px",
}

var vaMiddle = {
    verticalAlign: 'middle'
}

var TabHeaderStyle = {
    marginTop: '-15px',
    marginRight: '-15px',
    marginBottom: '0px',
    marginLeft: '-15px',
};

var TabHeaderBody = {
    marginTop: '0px',
    marginRight: '-15px',
    marginBottom: '-15px',
    marginLeft: '-15px',
};

class PresupuestoFormal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            presupuestoFormal: null,
            presupuestoFormalAux: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            presupuestoFormal: null,
            presupuestoFormalAux: null,
        })
    }

    setSelects(data) {
        if (data.allowed==true){
            this.setState({
                presupuestoFormalAux: (data.presupuestoFormal) ? (data.presupuestoFormal) : (null),
            });
        }
    }

    getData() {
        const { postVariables } = this.state;

        let data = {
            'presupuestoFormal': this.state.presupuestoFormal,
        };

        return data;
    }

    onChangeInput(tabN, input) {
        var i = parseInt(tabN);
        var newCostos = this.state.costos;
        newCostos[i].value = (input!=null && input!='') ? input : '0';
        this.setState({ costos: newCostos }, () => this.calculateCostos());
    }

    downloadPresupuestoFormal = () => {
        if (this.props.id && this.state.presupuestoFormalAux!=null) {
            window.open(api.proyectos.presupuesto.presupuestoformal.replace('$id_presupuesto', this.props.id()));
        }
    }

    render() {
        const { action } = this.props;
        const {presupuestoFormal, presupuestoFormalAux } = this.state;

        var subTotal = 0;
        return (
            <ParadigmaModal
                getUrl={api.proyectos.presupuesto.CargarPresupuestoFormal}
                postUrl={api.proyectos.presupuesto.CargarPresupuestoFormal}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Presupuesto Formal ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                notAllowedMessage={"El Presupuesto ya se encuentra cerrado."}
                title={"Cargar Presupuesto Formal"}
                buttonTitle={"Cargar Presupuesto Formal"}
                buttonIcon={"fa fa-file-text-o fa-lg"}
                className={"ui-modal-dialog ui-modal-md"}
                // onValidation={this.onValidation}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onPreSubmit={() => this.getData()}
                onClose={() => this.resetState()}

                fileUploader
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Presupuesto formal</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Archivo</Label>
                                {presupuestoFormalAux!=null &&
                                    <a onClick={()=>this.downloadPresupuestoFormal()} className={'xtDescarga'}>
                                        {'DESCARGAR'} {((presupuestoFormal!=null) ? (<i className="pl-4 txtDAdvertencia">{'(El archivo cargado será reemplazado.)'}</i>) : (''))}
                                    </a>
                                }
                                <Input onChange={e => this.setState({ presupuestoFormal: e.target.files[0] })} type="file" disabled={false} />
                            </div>
                        </div>
                    </section>
                </div>
                {/*<Row className="mt-3">
                    <Col className="col-12">
                        <Label>Facturas</Label>
                        <TableArchivos
                            action={'EDIT'}
                            archivos={documentosFacturas}
                            // onChange={documentosFacturas => this.onChangeField('documentosFacturas', documentosFacturas)}
                            onChange={data => this.setState({'documentosFacturas': data})}
                            url={api.proyectos.presupuesto.documento.replace('$id_proveedor', this.props.id())}
                        />
                    </Col>
                </Row>*/}


            </ParadigmaModal>
        );
    }
}

export default PresupuestoFormal;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento3/PresupuestoFormal.js